<template>
    <div class="ref-user-shared">
        <h5 class="ref-user-shared__title">Отправь приглашение друзьям:</h5>
        <div class="ref-user-shared__social">
            <div class="ref-user-shared__social-item" @click="sharedToTelegram">
                <img
                    src="~@/assets/images/ref-user-link/social/telegram.svg"
                    alt="Telegram"
                    class="ref-user-shared__social-item-image"
                />
                <span>Telegram</span>
            </div>
            <div class="ref-user-shared__social-item" @click="sharedToVK">
                <img
                    src="~@/assets/images/ref-user-link/social/vk.svg"
                    alt="ВКонтакте"
                    class="ref-user-shared__social-item-image"
                />
                <span>VK</span>
            </div>
            <div class="ref-user-shared__social-item" @click="sharedToWhatsApp">
                <img
                    src="~@/assets/images/ref-user-link/social/whatsapp.svg"
                    alt="WhatsApp"
                    class="ref-user-shared__social-item-image"
                />
                <span>WhatsApp</span>
            </div>
            <div class="ref-user-shared__social-item" @click="sharedToOK">
                <img
                    src="~@/assets/images/ref-user-link/social/ok.svg"
                    alt="Одноклассники"
                    class="ref-user-shared__social-item-image"
                />
                <span>OK</span>
            </div>

            <div class="ref-user-shared__social-item" @click="sharedToEmail">
                <img
                    src="~@/assets/images/ref-user-link/social/email.svg"
                    alt="Email"
                    class="ref-user-shared__social-item-image"
                />
                <span>Почта</span>
            </div>
            <div class="ref-user-shared__social-item">
                <RefUserButton
                    mini
                    is-full-event
                    only-copy
                    bgColor="#fff"
                    text="Копировать ссылку"
                    :ref-link="refLink"
                />
            </div>
        </div>
    </div>
</template>

<script>
import RefUserButton from './RefUserButton.vue';
//TODO отрефакторить
export default {
    name: 'RefUserShared',

    props: {
        refLink: {
            type: String,
            default: '',
        },
    },

    components: {
        RefUserButton,
    },

    data() {
        return {
            sharedText: `${this.refLink}`,

            sharedTextForVk:
                'Всероссийские проекты, стажировки, обучение у экспертов – шаг к твоим большим достижениям!',

            sharedTextForEmail: `
👋 Присоединяйся к президентской платформе «Россия – страна возможностей»!

🚀 Всероссийские проекты, стажировки, обучение у экспертов – шаг к твоим большим достижениям!

${this.refLink}
`,
        };
    },

    computed: {
        sharedEncodeText() {
            return encodeURIComponent(this.sharedText);
        },
        rsvDomain() {
            return window.rsvDomain || 'rsv.ru';
        },
    },

    methods: {
        sharedToTelegram() {
            window.open(`https://t.me/share/url?url=${encodeURIComponent(this.refLink)}&text=`, '_blank');
        },
        sharedToVK() {
            const shareUrl = 'https://vk.com/share.php';
            const params = new URLSearchParams({
                url: this.refLink,
                title: 'Присоединяйся к президентской платформе «Россия – страна возможностей»!',
                comment: this.sharedTextForVk,
                noparse: 'true',
            });

            window.open(`${shareUrl}?${params.toString()}`, '_blank');
        },
        sharedToWhatsApp() {
            const text = encodeURIComponent(this.sharedText);
            window.open(`https://api.whatsapp.com/send/?text=${text}`, '_blank');
        },
        sharedToOK() {
            window.open(
                `https://connect.ok.ru/offer?url=${encodeURIComponent(this.refLink)}&title=${this.sharedEncodeText}`,
                '_blank'
            );
        },
        sharedToEmail() {
            window.open(
                `mailto:?subject=Президентская платформа "Россия-страна возможностей" ждет именно тебя!&body=${encodeURIComponent(
                    this.sharedTextForEmail
                )}`,
                '_blank'
            );
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';

.ref-user-shared {
    &__title {
        font-size: urem(16);
        font-weight: 600;
        margin: 0 0 urem(16) 0;
    }

    &__social {
        display: flex;
        justify-content: center;
    }

    &__social-item {
        display: flex;
        align-items: center;
        flex-direction: column;
        cursor: pointer;
        width: urem(60);
        font-size: urem(10);
        gap: urem(6);

        span {
            font-weight: 500;
        }

        @include on-desktop {
            width: urem(70);
        }
    }

    &__social-item-image {
        width: urem(32);
        height: urem(32);

        @include on-desktop {
            width: urem(40);
            height: urem(40);
        }
    }
}
</style>
